import { FC } from "react";
import { ActivityRecord } from "../model";
import {
    parseAction,
    getComponentForEntityTypeAndChangeType,
    getComponentForChangeTypeAndTargetArea,
    formatLogMessage,
} from "./HistorySubRowHelpers";
import SubRowHistoryText from "./Components/SubRowHistoryText";
import SubRowErrorBoundary from "./Components/SubRowErrorBoundary";

const HistorySubRowContent: FC<{ activityRecord: ActivityRecord }> = ({
    activityRecord,
}) => {
    const parsedAction = parseAction(activityRecord.action);

    if (typeof parsedAction === "string") {
        const formattedLog = formatLogMessage(parsedAction);
        return <SubRowHistoryText action={formattedLog} />;
    }

    // New format has EntityType field
    if (parsedAction.EntityType) {
        return getComponentForEntityTypeAndChangeType(
            parsedAction.EntityType,
            parsedAction.ChangeType,
            parsedAction,
        );
    }

    // Fallback: old format routing via activityRecord numeric fields
    return getComponentForChangeTypeAndTargetArea(
        activityRecord.changeType,
        activityRecord.targetArea,
        parsedAction,
    );
};

const HistorySubRow: FC<{ activityRecord: ActivityRecord }> = ({
    activityRecord,
}) => (
    <SubRowErrorBoundary key={activityRecord.id}>
        <HistorySubRowContent activityRecord={activityRecord} />
    </SubRowErrorBoundary>
);

export default HistorySubRow;
